import { parseAsArrayOf } from 'nuqs';

import { useInvoiceFilters } from '~/api/invoices';
import { ColumnIds } from '~/constants/table';
import { SearchParamKeys } from '~/constants/url';
import { includes } from '~/utils/arrays';
import { createTableSearchParams, parseAsIntegerWithValidation, parseAsStringWithValidation } from '~/utils/nuqs';

export const {
  useColumnFilters: useInvoicesTableColumnFilters,
  useGlobalFilter: useInvoicesTableGlobalFilter,
  usePaginationState: useInvoicesTablePaginationState,
  useSorting: useInvoicesTableSorting,
} = createTableSearchParams({
  columnFilters: {
    [SearchParamKeys.columnFilterClient]: ColumnIds.invoicesClient,
    [SearchParamKeys.columnFilterBrand]: ColumnIds.invoicesBrand,
    [SearchParamKeys.columnFilterYears]: ColumnIds.invoicesDocYear,
    [SearchParamKeys.columnFilterQuarters]: ColumnIds.invoicesDocQuarter,
    [SearchParamKeys.columnFilterStatuses]: ColumnIds.invoicesStatus,
  },
  defaultSorting: { id: ColumnIds.invoicesDocDate, desc: true },
  sortableColumnIds: [
    ColumnIds.invoicesTitle,
    ColumnIds.invoicesClient,
    ColumnIds.invoicesDocDate,
    ColumnIds.invoicesStatus,
    ColumnIds.invoicesTotal,
    ColumnIds.invoicesAdvantage,
  ],
  sortingIdPrefix: 'invoices_',
  useColumnFilterParsers: () => {
    const { data: filters } = useInvoiceFilters();

    return {
      [SearchParamKeys.columnFilterClient]: parseAsIntegerWithValidation((value) => includes(filters.clientIds, value)),
      [SearchParamKeys.columnFilterBrand]: parseAsIntegerWithValidation((value) => includes(filters.brandIds, value)),
      [SearchParamKeys.columnFilterYears]: parseAsArrayOf(
        parseAsIntegerWithValidation((value) => includes(filters.years, value)),
      ).withDefault([]),
      [SearchParamKeys.columnFilterQuarters]: parseAsArrayOf(
        parseAsStringWithValidation((value) => includes(filters.quarters, value)),
      ).withDefault([]),
      [SearchParamKeys.columnFilterStatuses]: parseAsArrayOf(
        parseAsStringWithValidation((value) => includes(filters.statuses, value)),
      ).withDefault([]),
    };
  },
});
